module.exports = __webpack_public_path__ + "img/f380822.png";